import { Location } from "gen/company/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useAppSelector } from "app/hooks"
import { useListLocationsForCompanyQuery } from "features/api/company"
import { selectLocation } from "features/auth/authSlice"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useLocationFilter({
  persistInUrl = true,
  key = "location",
  label = "Location",
  initialSelectedOptions = [],
  defaultToSignedInLocation = false,
  allowExternalValues = false,
  filterActive = true,
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    | "persistInUrl"
    | "key"
    | "label"
    | "initialSelectedOptions"
    | "allowExternalValues"
  >
> & { defaultToSignedInLocation?: boolean; filterActive?: boolean } = {}) {
  const { data } = useListLocationsForCompanyQuery({ filterActive })
  const signedInLocation = useAppSelector(selectLocation)
  const initialOptions =
    defaultToSignedInLocation && signedInLocation
      ? [
          {
            key: UUID.idString(signedInLocation.id),
            value: signedInLocation.name,
          },
        ]
      : initialSelectedOptions

  const { filter, selected: selectedLocationIds } = useIdFilter({
    key,
    label,
    values: data?.locations ?? [],
    allowExternalValues,
    labelExtractor: (location: Location) =>
      !location.isActive ? `${location.name} - Inactive` : location.name,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions: initialOptions,
      }),
  })

  return { filter, selectedLocationIds }
}
